import React from 'react';
import { FaGlobe } from 'react-icons/fa';
import { useLang } from '../i18n/LanguageContext';
import './LanguageSwitcher.css';

function LanguageSwitcher({ className = '' }) {
    const { lang, setLang } = useLang();
    return (
        <div className={`lang-switcher ${className}`} role="group" aria-label="Language / Langue">
            <FaGlobe className="lang-switcher-icon" aria-hidden="true" />
            <button
                type="button"
                className={`lang-btn ${lang === 'fr' ? 'active' : ''}`}
                onClick={() => setLang('fr')}
                aria-pressed={lang === 'fr'}
            >
                FR
            </button>
            <span className="lang-sep">/</span>
            <button
                type="button"
                className={`lang-btn ${lang === 'en' ? 'active' : ''}`}
                
                onClick={() => setLang('en')}
                aria-pressed={lang === 'en'}
            >
                EN
            </button>
        </div>
    );
}

export default LanguageSwitcher;
